<div class="p-4 md:p-6">

  <!-- ═══ Header ═══ -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">dashboard</mat-icon>
      Dashboard Operaciones
    </h1>
    <p style="color: #6b7280; font-size: 0.85rem; margin-top: 4px;">
      Auto-actualización cada 30 segundos
    </p>
  </div>

  <!-- ═══ SECCIÓN 1: Operaciones por procesar + Completadas ═══ -->
  <div class="grid grid-cols-1 xl:grid-cols-3 gap-4 xl:gap-6 mb-6 xl:mb-8">

    <!-- Pendientes -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <!-- Header colapsable mobile -->
      <div (click)="toggleSection('pendientes')"
        class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
        [style.background]="expandedSections.has('pendientes') ? '#fffbeb' : 'white'">
        <div class="section-title" style="margin-bottom: 0;">
          <mat-icon style="color: #f59e0b; font-size: 22px; width: 22px; height: 22px;">pending_actions</mat-icon>
          <span>Por procesar</span>
        </div>
        <mat-icon class="xl:hidden" style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease;"
          [style.transform]="expandedSections.has('pendientes') ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>
      <!-- Contenido -->
      <div class="px-4 pb-4 xl:px-5 xl:pb-5"
        [class.hidden]="!expandedSections.has('pendientes')"
        [class.xl:block]="true">
        <div class="grid grid-cols-2 gap-3">
          <div class="pending-card" (click)="redirect('/wallet/admin/pending-transactons-cripto')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;"
              [ngClass]="{
                'blinking-text': pendingCount && pendingCount?.CRIPTO > 30,
                'blinking-text2': pendingCount && pendingCount?.CRIPTO <= 30 && pendingCount?.CRIPTO > 15
              }">USDT</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #111827; line-height: 1;"
              [ngClass]="{
                'blinking-text': pendingCount && pendingCount?.CRIPTO > 30,
                'blinking-text2': pendingCount && pendingCount?.CRIPTO <= 30 && pendingCount?.CRIPTO > 15
              }">{{ pendingCount ? pendingCount?.CRIPTO : '...' }}</p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Pendientes</span>
          </div>

          <div class="pending-card" (click)="redirect('/wallet/admin/transactions')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;"
              [ngClass]="{
                'blinking-text': pendingCount && pendingCount?.FIAT > 30,
                'blinking-text2': pendingCount && pendingCount?.FIAT <= 30 && pendingCount?.FIAT > 15
              }">FIAT VES</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #111827; line-height: 1;"
              [ngClass]="{
                'blinking-text': pendingCount && pendingCount?.FIAT > 30,
                'blinking-text2': pendingCount && pendingCount?.FIAT <= 30 && pendingCount?.FIAT > 15
              }">{{ pendingCount ? pendingCount?.FIAT : '...' }}</p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Pendientes</span>
          </div>

          <div class="pending-card" (click)="redirect('/wallet/admin/pending-transactions-zelle')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;"
              [ngClass]="{
                'blinking-text': pendingCount && pendingCount?.ZELLE > 30,
                'blinking-text2': pendingCount && pendingCount?.ZELLE <= 30 && pendingCount?.ZELLE > 15
              }">Zelle</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #111827; line-height: 1;"
              [ngClass]="{
                'blinking-text': pendingCount && pendingCount?.ZELLE > 30,
                'blinking-text2': pendingCount && pendingCount?.ZELLE <= 30 && pendingCount?.ZELLE > 15
              }">{{ pendingCount ? pendingCount?.ZELLE : '...' }}</p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Pendientes</span>
          </div>

          <div class="pending-card" (click)="redirect('/wallet/admin/withdraw-transactions')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;"
              [ngClass]="{
                'blinking-text': pendingCount && pendingCount?.RETIRO > 30,
                'blinking-text2': pendingCount && pendingCount?.RETIRO <= 30 && pendingCount?.RETIRO > 15
              }">Retiro FIAT</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #111827; line-height: 1;"
              [ngClass]="{
                'blinking-text': pendingCount && pendingCount?.RETIRO > 30,
                'blinking-text2': pendingCount && pendingCount?.RETIRO <= 30 && pendingCount?.RETIRO > 15
              }">{{ pendingCount ? pendingCount?.RETIRO : '...' }}</p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Pendientes</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Completadas Hoy -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div (click)="toggleSection('completadasHoy')"
        class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
        [style.background]="expandedSections.has('completadasHoy') ? '#f0fdf4' : 'white'">
        <div class="section-title" style="margin-bottom: 0;">
          <mat-icon style="color: #16a34a; font-size: 22px; width: 22px; height: 22px;">check_circle</mat-icon>
          <span>Completadas hoy</span>
          <span style="font-size: 0.75rem; font-weight: 500; color: #6b7280; margin-left: 8px;">{{ formatDate(todayDate) }}</span>
        </div>
        <mat-icon class="xl:hidden" style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease;"
          [style.transform]="expandedSections.has('completadasHoy') ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>
      <div class="px-4 pb-4 xl:px-5 xl:pb-5"
        [class.hidden]="!expandedSections.has('completadasHoy')"
        [class.xl:block]="true">
        <div class="grid grid-cols-2 gap-3">
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('currentDay', 'CRIPTO')"
            (keyup.enter)="verOperaciones('currentDay', 'CRIPTO')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">USDT</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #16a34a; line-height: 1;">
              {{ completedCount?.currentDay ? completedCount?.currentDay.CRIPTO : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('currentDay', 'CRIPTO') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('currentDay', 'FIAT')"
            (keyup.enter)="verOperaciones('currentDay', 'FIAT')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">FIAT VES</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #16a34a; line-height: 1;">
              {{ completedCount?.currentDay ? completedCount?.currentDay.FIAT : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('currentDay', 'FIAT') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('currentDay', 'ZELLE')"
            (keyup.enter)="verOperaciones('currentDay', 'ZELLE')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Zelle</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #16a34a; line-height: 1;">
              {{ completedCount?.currentDay ? completedCount?.currentDay.ZELLE : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('currentDay', 'ZELLE') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('currentDay', 'RETIRO')"
            (keyup.enter)="verOperaciones('currentDay', 'RETIRO')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Retiro FIAT</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #16a34a; line-height: 1;">
              {{ completedCount?.currentDay ? completedCount?.currentDay.RETIRO : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('currentDay', 'RETIRO') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
          <!-- RETIRO_VES ahora cuenta como FIAT: sus operaciones se ven en la
               tarjeta "FIAT VES". Se elimino la tarjeta propia "Retiro VES". -->
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('currentDay', 'SWAP_USDT_VES')"
            (keyup.enter)="verOperaciones('currentDay', 'SWAP_USDT_VES')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Swap USDT/VES</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #16a34a; line-height: 1;">
              {{ completedCount?.currentDay ? (completedCount?.currentDay.SWAP_USDT_VES || 0) : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('currentDay', 'SWAP_USDT_VES') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('currentDay', 'REMESA_INTL')"
            (keyup.enter)="verOperaciones('currentDay', 'REMESA_INTL')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Remesas COP/PEN</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #16a34a; line-height: 1;">
              {{ completedCount?.currentDay ? (completedCount?.currentDay.REMESA_INTL || 0) : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('currentDay', 'REMESA_INTL') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Completadas Ayer -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div (click)="toggleSection('completadasAyer')"
        class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
        [style.background]="expandedSections.has('completadasAyer') ? '#f3f4f6' : 'white'">
        <div class="section-title" style="margin-bottom: 0;">
          <mat-icon style="color: #6b7280; font-size: 22px; width: 22px; height: 22px;">history</mat-icon>
          <span>Completadas ayer</span>
          <span style="font-size: 0.75rem; font-weight: 500; color: #6b7280; margin-left: 8px;">{{ formatDate(yesterdayDate) }}</span>
        </div>
        <mat-icon class="xl:hidden" style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease;"
          [style.transform]="expandedSections.has('completadasAyer') ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>
      <div class="px-4 pb-4 xl:px-5 xl:pb-5"
        [class.hidden]="!expandedSections.has('completadasAyer')"
        [class.xl:block]="true">
        <div class="grid grid-cols-2 gap-3">
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('previousDay', 'CRIPTO')"
            (keyup.enter)="verOperaciones('previousDay', 'CRIPTO')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">USDT</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #374151; line-height: 1;">
              {{ completedCount?.previousDay ? completedCount?.previousDay.CRIPTO : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('previousDay', 'CRIPTO') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('previousDay', 'FIAT')"
            (keyup.enter)="verOperaciones('previousDay', 'FIAT')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">FIAT VES</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #374151; line-height: 1;">
              {{ completedCount?.previousDay ? completedCount?.previousDay.FIAT : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('previousDay', 'FIAT') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('previousDay', 'ZELLE')"
            (keyup.enter)="verOperaciones('previousDay', 'ZELLE')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Zelle</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #374151; line-height: 1;">
              {{ completedCount?.previousDay ? completedCount?.previousDay.ZELLE : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('previousDay', 'ZELLE') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('previousDay', 'RETIRO')"
            (keyup.enter)="verOperaciones('previousDay', 'RETIRO')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Retiro FIAT</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #374151; line-height: 1;">
              {{ completedCount?.previousDay ? completedCount?.previousDay.RETIRO : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('previousDay', 'RETIRO') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
          <!-- RETIRO_VES ahora cuenta como FIAT: se ve en la tarjeta "FIAT VES".
               Se elimino la tarjeta propia "Retiro VES". -->
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('previousDay', 'SWAP_USDT_VES')"
            (keyup.enter)="verOperaciones('previousDay', 'SWAP_USDT_VES')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Swap USDT/VES</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #374151; line-height: 1;">
              {{ completedCount?.previousDay ? (completedCount?.previousDay.SWAP_USDT_VES || 0) : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('previousDay', 'SWAP_USDT_VES') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
          <div class="info-card info-card-link" role="button" tabindex="0"
            matTooltip="Ver el detalle de estas operaciones"
            (click)="verOperaciones('previousDay', 'REMESA_INTL')"
            (keyup.enter)="verOperaciones('previousDay', 'REMESA_INTL')">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Remesas COP/PEN</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #374151; line-height: 1;">
              {{ completedCount?.previousDay ? (completedCount?.previousDay.REMESA_INTL || 0) : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Completadas</span>
            <div class="totals-line" *ngIf="totalsFor('previousDay', 'REMESA_INTL') as totales">
              <span class="total-destino" *ngFor="let monto of totales.destino">{{ formatMonto(monto) }}</span>
              <span class="total-origen" *ngFor="let monto of totales.origen">{{ formatMonto(monto) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ SECCIÓN 2: Operaciones USDT ═══ -->
  <div class="grid grid-cols-1 xl:grid-cols-3 gap-4 xl:gap-6 mb-6 xl:mb-8">

    <!-- Retiros USDT por procesar -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div (click)="toggleSection('retirosUsdt')"
        class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
        [style.background]="expandedSections.has('retirosUsdt') ? '#fffbeb' : 'white'">
        <div class="section-title" style="margin-bottom: 0;">
          <mat-icon style="color: #f59e0b; font-size: 22px; width: 22px; height: 22px;">account_balance_wallet</mat-icon>
          <span>Retiros USDT</span>
        </div>
        <mat-icon class="xl:hidden" style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease;"
          [style.transform]="expandedSections.has('retirosUsdt') ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>
      <div class="px-4 pb-4 xl:px-5 xl:pb-5"
        [class.hidden]="!expandedSections.has('retirosUsdt')"
        [class.xl:block]="true">
        <div class="flex justify-center">
          <div class="pending-card" style="min-width: 160px;"
            (click)="redirect('/wallet/admin/wallets-admin-send-usdt')"
            [ngClass]="{
              'blinking-text': pendingWithdrawals && pendingWithdrawals.count > 10,
              'blinking-text2': pendingWithdrawals && pendingWithdrawals.count <= 10 && pendingWithdrawals.count > 5
            }">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;"
              [ngClass]="{
                'blinking-text': pendingWithdrawals && pendingWithdrawals.count > 10,
                'blinking-text2': pendingWithdrawals && pendingWithdrawals.count <= 10 && pendingWithdrawals.count > 5
              }">Por Aprobar</h3>
            <p style="font-size: 2.2rem; font-weight: 800; color: #111827; line-height: 1;"
              [ngClass]="{
                'blinking-text': pendingWithdrawals && pendingWithdrawals.count > 10,
                'blinking-text2': pendingWithdrawals && pendingWithdrawals.count <= 10 && pendingWithdrawals.count > 5
              }">{{ pendingWithdrawals ? pendingWithdrawals.count : '...' }}</p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Pendientes</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Operaciones USDT Hoy -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div (click)="toggleSection('usdtHoy')"
        class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
        [style.background]="expandedSections.has('usdtHoy') ? '#f0fdf4' : 'white'">
        <div class="section-title" style="margin-bottom: 0;">
          <mat-icon style="color: #16a34a; font-size: 22px; width: 22px; height: 22px;">today</mat-icon>
          <span>USDT Hoy</span>
          <span style="font-size: 0.75rem; font-weight: 500; color: #6b7280; margin-left: 8px;">{{ formatDate(todayDate) }}</span>
        </div>
        <mat-icon class="xl:hidden" style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease;"
          [style.transform]="expandedSections.has('usdtHoy') ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>
      <div class="px-4 pb-4 xl:px-5 xl:pb-5"
        [class.hidden]="!expandedSections.has('usdtHoy')"
        [class.xl:block]="true">
        <div class="grid grid-cols-2 gap-3">
          <div class="info-card">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Conversiones</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #16a34a; line-height: 1;">
              {{ todayOperations ? todayOperations.conversions.count : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">USDT a CLP</span>
          </div>
          <div class="info-card">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Depósitos</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #16a34a; line-height: 1;">
              {{ todayOperations ? todayOperations.deposits.count : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Carga USDT</span>
          </div>
          <div class="info-card" style="grid-column: 1 / -1;">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 8px;">Retiros USDT</h3>
            <div *ngIf="todayOperations" style="display: flex; flex-direction: column; gap: 4px;">
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 4px 8px; background: #f0fdf4; border-radius: 6px;">
                <span style="font-size: 0.8rem; font-weight: 600; color: #374151;">Total</span>
                <span style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">{{ todayOperations.withdrawals.total.count }}</span>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 3px 8px;">
                <span style="font-size: 0.75rem; color: #6b7280;">Pendientes</span>
                <span style="font-size: 0.85rem; font-weight: 700; color: #eab308;">{{ todayOperations.withdrawals.byStatus.pending.count }}</span>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 3px 8px;">
                <span style="font-size: 0.75rem; color: #6b7280;">Completadas</span>
                <span style="font-size: 0.85rem; font-weight: 700; color: #16a34a;">{{ todayOperations.withdrawals.byStatus.completed.count }}</span>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 3px 8px;">
                <span style="font-size: 0.75rem; color: #6b7280;">Rechazadas</span>
                <span style="font-size: 0.85rem; font-weight: 700; color: #dc2626;">{{ todayOperations.withdrawals.byStatus.rejected.count }}</span>
              </div>
              <div *ngIf="todayOperations.withdrawals.byStatus.cancelled.count > 0"
                style="display: flex; justify-content: space-between; align-items: center; padding: 3px 8px;">
                <span style="font-size: 0.75rem; color: #6b7280;">Canceladas</span>
                <span style="font-size: 0.85rem; font-weight: 700; color: #991b1b;">{{ todayOperations.withdrawals.byStatus.cancelled.count }}</span>
              </div>
            </div>
            <p *ngIf="!todayOperations" style="color: #9ca3af; font-size: 0.85rem;">Cargando...</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Operaciones USDT Ayer -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div (click)="toggleSection('usdtAyer')"
        class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
        [style.background]="expandedSections.has('usdtAyer') ? '#f3f4f6' : 'white'">
        <div class="section-title" style="margin-bottom: 0;">
          <mat-icon style="color: #6b7280; font-size: 22px; width: 22px; height: 22px;">event</mat-icon>
          <span>USDT Ayer</span>
          <span style="font-size: 0.75rem; font-weight: 500; color: #6b7280; margin-left: 8px;">{{ formatDate(yesterdayDate) }}</span>
        </div>
        <mat-icon class="xl:hidden" style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease;"
          [style.transform]="expandedSections.has('usdtAyer') ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>
      <div class="px-4 pb-4 xl:px-5 xl:pb-5"
        [class.hidden]="!expandedSections.has('usdtAyer')"
        [class.xl:block]="true">
        <div class="grid grid-cols-2 gap-3">
          <div class="info-card">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Conversiones</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #374151; line-height: 1;">
              {{ yesterdayOperations ? yesterdayOperations.conversions.count : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">USDT a CLP</span>
          </div>
          <div class="info-card">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 4px;">Depósitos</h3>
            <p style="font-size: 1.8rem; font-weight: 800; color: #374151; line-height: 1;">
              {{ yesterdayOperations ? yesterdayOperations.deposits.count : '...' }}
            </p>
            <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">Carga USDT</span>
          </div>
          <div class="info-card" style="grid-column: 1 / -1;">
            <h3 style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 8px;">Retiros USDT</h3>
            <div *ngIf="yesterdayOperations" style="display: flex; flex-direction: column; gap: 4px;">
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 4px 8px; background: #f3f4f6; border-radius: 6px;">
                <span style="font-size: 0.8rem; font-weight: 600; color: #374151;">Total</span>
                <span style="font-size: 1.1rem; font-weight: 800; color: #374151;">{{ yesterdayOperations.withdrawals.total.count }}</span>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 3px 8px;">
                <span style="font-size: 0.75rem; color: #6b7280;">Pendientes</span>
                <span style="font-size: 0.85rem; font-weight: 700; color: #eab308;">{{ yesterdayOperations.withdrawals.byStatus.pending.count }}</span>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 3px 8px;">
                <span style="font-size: 0.75rem; color: #6b7280;">Completadas</span>
                <span style="font-size: 0.85rem; font-weight: 700; color: #16a34a;">{{ yesterdayOperations.withdrawals.byStatus.completed.count }}</span>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 3px 8px;">
                <span style="font-size: 0.75rem; color: #6b7280;">Rechazadas</span>
                <span style="font-size: 0.85rem; font-weight: 700; color: #dc2626;">{{ yesterdayOperations.withdrawals.byStatus.rejected.count }}</span>
              </div>
              <div *ngIf="yesterdayOperations.withdrawals.byStatus.cancelled.count > 0"
                style="display: flex; justify-content: space-between; align-items: center; padding: 3px 8px;">
                <span style="font-size: 0.75rem; color: #6b7280;">Canceladas</span>
                <span style="font-size: 0.85rem; font-weight: 700; color: #991b1b;">{{ yesterdayOperations.withdrawals.byStatus.cancelled.count }}</span>
              </div>
            </div>
            <p *ngIf="!yesterdayOperations" style="color: #9ca3af; font-size: 0.85rem;">Cargando...</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ SECCIÓN 3: Tasas Publicadas ═══ -->
  <div class="mb-6 xl:mb-8" *ngIf="currentValues && currentRates">
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div (click)="toggleSection('tasas')"
        class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
        [style.background]="expandedSections.has('tasas') ? '#f5f3ff' : 'white'">
        <div class="section-title" style="margin-bottom: 0;">
          <mat-icon style="color: #7c3aed; font-size: 22px; width: 22px; height: 22px;">currency_exchange</mat-icon>
          <span>Tasas Publicadas</span>
        </div>
        <mat-icon class="xl:hidden" style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease;"
          [style.transform]="expandedSections.has('tasas') ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>
      <div class="px-4 pb-4 xl:px-5 xl:pb-5"
        [class.hidden]="!expandedSections.has('tasas')"
        [class.xl:block]="true">

        <div class="flex flex-col lg:flex-row gap-6">
          <!-- Tasas principales -->
          <div style="min-width: 220px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-radius: 14px; padding: 20px;">
            <div style="margin-bottom: 16px;">
              <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.05em;">USDT/CLP Venta</span>
              <p style="font-size: 1.5rem; font-weight: 800; color: #1e5a3f; margin-top: 2px;">
                {{ usdt_clp_tax | number:'1.2-2' }}
              </p>
            </div>
            <div style="margin-bottom: 16px;">
              <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.05em;">USDT/CLP Compra</span>
              <p style="font-size: 1.5rem; font-weight: 800; color: #1e5a3f; margin-top: 2px;">
                {{ usdt_clp_tax_buy | number:'1.2-2' }}
              </p>
            </div>
            <div style="border-top: 1px solid #bbf7d0; padding-top: 12px; margin-bottom: 16px;">
              <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.05em;">Venta Zelle</span>
              <p style="font-size: 1.5rem; font-weight: 800; color: #1e5a3f; margin-top: 2px;">
                {{ zelleSellValue | number:'1.2-2' }}
              </p>
            </div>
            <div>
              <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.05em;">Compra Zelle</span>
              <p style="font-size: 1.5rem; font-weight: 800; color: #1e5a3f; margin-top: 2px;">
                {{ zelleBuyValue | number:'1.2-2' }}
              </p>
            </div>
          </div>

          <!-- Tasas FIAT por banco -->
          <div class="flex-1">
            <h3 style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin-bottom: 12px;">FIAT - Tasas por banco</h3>

            <!-- Mínimo -->
            <div style="margin-bottom: 16px;">
              <div style="display: inline-flex; align-items: center; gap: 6px; background: #eff6ff; padding: 4px 12px; border-radius: 20px; margin-bottom: 10px;">
                <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">arrow_downward</mat-icon>
                <span style="font-size: 0.75rem; font-weight: 700; color: #2563eb;">
                  Mínimo {{ currentValues.limiteInferior | currency:'':'':'1.0-0' }} BS
                </span>
              </div>
              <div class="flex flex-row gap-3 flex-wrap">
                <app-rate-value-card [bank]="'Banesco'" [rateOrigin]="currentRates.valoresVES.valorBanesco"
                  [imgUrl]="'assets/img/bancos/banesco.png'" [rateDestination]="currentRates.minimo.tasaBanesco"
                  style="width: 180px;"></app-rate-value-card>
                <app-rate-value-card [bank]="'Mercantil'" [rateOrigin]="currentRates.valoresVES.valorMercantil"
                  [imgUrl]="'assets/img/bancos/mercantil.png'" [rateDestination]="currentRates.minimo.tasaMercantil"
                  style="width: 180px;"></app-rate-value-card>
                <app-rate-value-card [bank]="'Provincial'" [rateOrigin]="currentRates.valoresVES.valorProvincial"
                  [imgUrl]="'assets/img/bancos/provincial.png'" [rateDestination]="currentRates.minimo.tasaProvincial"
                  style="width: 180px;"></app-rate-value-card>
                <app-rate-value-card [bank]="'Venezuela'" [rateOrigin]="currentRates.valoresVES.valorVenezuela"
                  [imgUrl]="'assets/img/bancos/venezuela.png'" [rateDestination]="currentRates.minimo.tasaVenezuela"
                  style="width: 180px;"></app-rate-value-card>
              </div>
            </div>

            <!-- Máximo -->
            <div>
              <div style="display: inline-flex; align-items: center; gap: 6px; background: #fef3c7; padding: 4px 12px; border-radius: 20px; margin-bottom: 10px;">
                <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #f59e0b;">arrow_upward</mat-icon>
                <span style="font-size: 0.75rem; font-weight: 700; color: #f59e0b;">
                  Máximo {{ currentValues.limiteSuperior }} BS
                </span>
              </div>
              <div class="flex flex-row gap-3 flex-wrap">
                <app-rate-value-card [bank]="'Banesco'" [rateOrigin]="currentRates.valoresVES.valorBanesco"
                  [imgUrl]="'assets/img/bancos/banesco.png'" [rateDestination]="currentRates.maximo.tasaBanesco"
                  style="width: 180px;"></app-rate-value-card>
                <app-rate-value-card [bank]="'Mercantil'" [rateOrigin]="currentRates.valoresVES.valorMercantil"
                  [imgUrl]="'assets/img/bancos/mercantil.png'" [rateDestination]="currentRates.maximo.tasaMercantil"
                  style="width: 180px;"></app-rate-value-card>
                <app-rate-value-card [bank]="'Provincial'" [rateOrigin]="currentRates.valoresVES.valorProvincial"
                  [imgUrl]="'assets/img/bancos/provincial.png'" [rateDestination]="currentRates.maximo.tasaProvincial"
                  style="width: 180px;"></app-rate-value-card>
                <app-rate-value-card [bank]="'Venezuela'" [rateOrigin]="currentRates.valoresVES.valorVenezuela"
                  [imgUrl]="'assets/img/bancos/venezuela.png'" [rateDestination]="currentRates.maximo.tasaVenezuela"
                  style="width: 180px;"></app-rate-value-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ SECCIÓN 4: Folios disponibles ═══ -->
  <div class="mb-6 xl:mb-8">
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div (click)="toggleSection('folios')"
        class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
        [style.background]="expandedSections.has('folios') ? '#eff6ff' : 'white'">
        <div class="section-title" style="margin-bottom: 0;">
          <mat-icon style="color: #2563eb; font-size: 22px; width: 22px; height: 22px;">receipt_long</mat-icon>
          <span>Folios disponibles</span>
        </div>
        <mat-icon class="xl:hidden" style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease;"
          [style.transform]="expandedSections.has('folios') ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>
      <div class="px-4 pb-4 xl:px-5 xl:pb-5"
        [class.hidden]="!expandedSections.has('folios')"
        [class.xl:block]="true">

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

          <!-- Aguacate -->
          <div *ngIf="foliosAguacate" class="folio-card">
            <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 8px; border-radius: 10px; margin-bottom: 12px;">
              <h3 style="font-size: 1rem; font-weight: 800; color: #1e5a3f;">Aguacate</h3>
            </div>
            <div style="display: flex; flex-direction: column; gap: 8px;">
              <div>
                <span style="font-size: 0.75rem; color: #6b7280; font-weight: 600;">Boletas</span>
                <div style="padding: 6px; border-radius: 8px; margin-top: 4px;"
                  [ngClass]="{
                    'bg-red-100 text-red-700': foliosAguacateBoletas < 100,
                    'bg-yellow-100 text-yellow-700': foliosAguacateBoletas < 250 && foliosAguacateBoletas >= 100,
                    'bg-green-50 text-green-700': foliosAguacateBoletas >= 250
                  }">
                  <span style="font-size: 1.3rem; font-weight: 800;">{{ foliosAguacateBoletas }}</span>
                </div>
              </div>
              <div>
                <span style="font-size: 0.75rem; color: #6b7280; font-weight: 600;">Facturas</span>
                <div style="padding: 6px; border-radius: 8px; margin-top: 4px;"
                  [ngClass]="{
                    'bg-red-100 text-red-700': foliosAguacateFacturas < 100,
                    'bg-yellow-100 text-yellow-700': foliosAguacateFacturas < 250 && foliosAguacateFacturas >= 100,
                    'bg-green-50 text-green-700': foliosAguacateFacturas >= 250
                  }">
                  <span style="font-size: 1.3rem; font-weight: 800;">{{ foliosAguacateFacturas }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Parra -->
          <div *ngIf="foliosParra" class="folio-card">
            <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 8px; border-radius: 10px; margin-bottom: 12px;">
              <h3 style="font-size: 1rem; font-weight: 800; color: #1e40af;">Parra</h3>
            </div>
            <div style="display: flex; flex-direction: column; gap: 8px;">
              <div>
                <span style="font-size: 0.75rem; color: #6b7280; font-weight: 600;">Boletas</span>
                <div style="padding: 6px; border-radius: 8px; margin-top: 4px;"
                  [ngClass]="{
                    'bg-red-100 text-red-700': foliosParraBoletas < 100,
                    'bg-yellow-100 text-yellow-700': foliosParraBoletas < 250 && foliosParraBoletas >= 100,
                    'bg-green-50 text-green-700': foliosParraBoletas >= 250
                  }">
                  <span style="font-size: 1.3rem; font-weight: 800;">{{ foliosParraBoletas }}</span>
                </div>
              </div>
              <div>
                <span style="font-size: 0.75rem; color: #6b7280; font-weight: 600;">Facturas</span>
                <div style="padding: 6px; border-radius: 8px; margin-top: 4px;"
                  [ngClass]="{
                    'bg-red-100 text-red-700': foliosParraFacturas < 100,
                    'bg-yellow-100 text-yellow-700': foliosParraFacturas < 250 && foliosParraFacturas >= 100,
                    'bg-green-50 text-green-700': foliosParraFacturas >= 250
                  }">
                  <span style="font-size: 1.3rem; font-weight: 800;">{{ foliosParraFacturas }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Fábrica Rosa -->
          <div *ngIf="foliosParra" class="folio-card">
            <div style="background: linear-gradient(135deg, #fdf2f8, #fce7f3); padding: 8px; border-radius: 10px; margin-bottom: 12px;">
              <h3 style="font-size: 1rem; font-weight: 800; color: #9d174d;">Fábrica Rosa</h3>
            </div>
            <div style="display: flex; flex-direction: column; gap: 8px;">
              <div>
                <span style="font-size: 0.75rem; color: #6b7280; font-weight: 600;">Boletas</span>
                <div style="padding: 6px; border-radius: 8px; margin-top: 4px;"
                  [ngClass]="{
                    'bg-red-100 text-red-700': foliosFabricaRosaBoletas < 100,
                    'bg-yellow-100 text-yellow-700': foliosFabricaRosaBoletas < 250 && foliosFabricaRosaBoletas >= 100,
                    'bg-green-50 text-green-700': foliosFabricaRosaBoletas >= 250
                  }">
                  <span style="font-size: 1.3rem; font-weight: 800;">{{ foliosFabricaRosaBoletas }}</span>
                </div>
              </div>
              <div>
                <span style="font-size: 0.75rem; color: #6b7280; font-weight: 600;">Facturas</span>
                <div style="padding: 6px; border-radius: 8px; margin-top: 4px;"
                  [ngClass]="{
                    'bg-red-100 text-red-700': foliosFabricaRosaFacturas < 100,
                    'bg-yellow-100 text-yellow-700': foliosFabricaRosaFacturas < 250 && foliosFabricaRosaFacturas >= 100,
                    'bg-green-50 text-green-700': foliosFabricaRosaFacturas >= 250
                  }">
                  <span style="font-size: 1.3rem; font-weight: 800;">{{ foliosFabricaRosaFacturas }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Avocado Tech -->
          <div *ngIf="foliosAvocadoTech" class="folio-card">
            <div style="background: linear-gradient(135deg, #fefce8, #fef9c3); padding: 8px; border-radius: 10px; margin-bottom: 12px;">
              <h3 style="font-size: 1rem; font-weight: 800; color: #854d0e;">Avocado Tech</h3>
            </div>
            <div style="display: flex; flex-direction: column; gap: 8px;">
              <div>
                <span style="font-size: 0.75rem; color: #6b7280; font-weight: 600;">Boletas</span>
                <div style="padding: 6px; border-radius: 8px; margin-top: 4px;"
                  [ngClass]="{
                    'bg-red-100 text-red-700': foliosAvocadoTechBoletas < 100,
                    'bg-yellow-100 text-yellow-700': foliosAvocadoTechBoletas < 250 && foliosAvocadoTechBoletas >= 100,
                    'bg-green-50 text-green-700': foliosAvocadoTechBoletas >= 250
                  }">
                  <span style="font-size: 1.3rem; font-weight: 800;">{{ foliosAvocadoTechBoletas }}</span>
                </div>
              </div>
              <div>
                <span style="font-size: 0.75rem; color: #6b7280; font-weight: 600;">Facturas</span>
                <div style="padding: 6px; border-radius: 8px; margin-top: 4px;"
                  [ngClass]="{
                    'bg-red-100 text-red-700': foliosAvocadoTechFacturas < 100,
                    'bg-yellow-100 text-yellow-700': foliosAvocadoTechFacturas < 250 && foliosAvocadoTechFacturas >= 100,
                    'bg-green-50 text-green-700': foliosAvocadoTechFacturas >= 250
                  }">
                  <span style="font-size: 1.3rem; font-weight: 800;">{{ foliosAvocadoTechFacturas }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
